{
 "schemaVersion": 1,
 "source": "Grout color chart image, 40 colors; hex values sampled from the swatch image and are approximate screen colors, not manufacturer references",
 "defaultGroutId": "brw",
 "colors": [
  {
   "id": "brw",
   "code": "BRW",
   "name": "Bright White",
   "hex": "#EBE5DA",
   "row": 1,
   "col": 1
  },
  {
   "id": "sau",
   "code": "SAU",
   "name": "Sauterne",
   "hex": "#EDE8E4",
   "row": 1,
   "col": 2
  },
  {
   "id": "sis",
   "code": "SIS",
   "name": "Silver Shadow",
   "hex": "#E6E7E7",
   "row": 1,
   "col": 3
  },
  {
   "id": "fro",
   "code": "FRO",
   "name": "Frosty",
   "hex": "#D3D3D0",
   "row": 1,
   "col": 4
  },
  {
   "id": "alm",
   "code": "ALM",
   "name": "Almond",
   "hex": "#E4E3CE",
   "row": 1,
   "col": 5
  },
  {
   "id": "sil",
   "code": "SIL",
   "name": "Silk",
   "hex": "#F9E2C0",
   "row": 1,
   "col": 6
  },
  {
   "id": "mus",
   "code": "MUS",
   "name": "Mushroom",
   "hex": "#F0E2C1",
   "row": 1,
   "col": 7
  },
  {
   "id": "buc",
   "code": "BUC",
   "name": "Butter Cream",
   "hex": "#E4CEA5",
   "row": 1,
   "col": 8
  },
  {
   "id": "min",
   "code": "MIN",
   "name": "Mink",
   "hex": "#BCBFC1",
   "row": 2,
   "col": 1
  },
  {
   "id": "mbe",
   "code": "MBE",
   "name": "Marble Beige",
   "hex": "#D5C7B8",
   "row": 2,
   "col": 2
  },
  {
   "id": "lip",
   "code": "LIP",
   "name": "Light Pewter",
   "hex": "#B9AF9D",
   "row": 2,
   "col": 3
  },
  {
   "id": "sts",
   "code": "STS",
   "name": "Sterling Silver",
   "hex": "#B4A799",
   "row": 2,
   "col": 4
  },
  {
   "id": "tal",
   "code": "TAL",
   "name": "Toasted Almond",
   "hex": "#CFB998",
   "row": 2,
   "col": 5
  },
  {
   "id": "fos",
   "code": "FOS",
   "name": "Fossil",
   "hex": "#C8C0B7",
   "row": 2,
   "col": 6
  },
  {
   "id": "iro",
   "code": "IRO",
   "name": "Iron",
   "hex": "#C3C5C7",
   "row": 2,
   "col": 7
  },
  {
   "id": "ste",
   "code": "STE",
   "name": "Steamship",
   "hex": "#BABDC1",
   "row": 2,
   "col": 8
  },
  {
   "id": "wal",
   "code": "WAL",
   "name": "Walnut",
   "hex": "#B7AFA5",
   "row": 3,
   "col": 1
  },
  {
   "id": "anw",
   "code": "ANW",
   "name": "Antique White",
   "hex": "#CBC3B0",
   "row": 3,
   "col": 2
  },
  {
   "id": "nag",
   "code": "NAG",
   "name": "Natural Grey",
   "hex": "#B0A990",
   "row": 3,
   "col": 3
  },
  {
   "id": "dkh",
   "code": "DKH",
   "name": "Desert Khaki",
   "hex": "#9C927C",
   "row": 3,
   "col": 4
  },
  {
   "id": "lat",
   "code": "LAT",
   "name": "Latte",
   "hex": "#B1A28F",
   "row": 3,
   "col": 5
  },
  {
   "id": "par",
   "code": "PAR",
   "name": "Parchment",
   "hex": "#BFA983",
   "row": 3,
   "col": 6
  },
  {
   "id": "sab",
   "code": "SAB",
   "name": "Sand Beige",
   "hex": "#9F7C5C",
   "row": 3,
   "col": 7
  },
  {
   "id": "hoc",
   "code": "HOC",
   "name": "Hot Cocoa",
   "hex": "#958783",
   "row": 3,
   "col": 8
  },
  {
   "id": "smg",
   "code": "SMG",
   "name": "Smoke Grey",
   "hex": "#B0B6B0",
   "row": 4,
   "col": 1
  },
  {
   "id": "sgr",
   "code": "SGR",
   "name": "Stormy Grey",
   "hex": "#A1A29A",
   "row": 4,
   "col": 2
  },
  {
   "id": "moc",
   "code": "MOC",
   "name": "Mocha",
   "hex": "#715F4E",
   "row": 4,
   "col": 3
  },
  {
   "id": "pla",
   "code": "PLA",
   "name": "Platinum",
   "hex": "#435A63",
   "row": 4,
   "col": 4
  },
  {
   "id": "sas",
   "code": "SAS",
   "name": "Sandstone",
   "hex": "#7D6962",
   "row": 4,
   "col": 5
  },
  {
   "id": "hem",
   "code": "HEM",
   "name": "Hemp",
   "hex": "#746256",
   "row": 4,
   "col": 6
  },
  {
   "id": "qur",
   "code": "QUR",
   "name": "Quarry Red",
   "hex": "#884540",
   "row": 4,
   "col": 7
  },
  {
   "id": "tec",
   "code": "TEC",
   "name": "Terra Cotta",
   "hex": "#6E3A32",
   "row": 4,
   "col": 8
  },
  {
   "id": "dug",
   "code": "DUG",
   "name": "Dusty Grey",
   "hex": "#5A5F63",
   "row": 5,
   "col": 1
  },
  {
   "id": "cbr",
   "code": "CBR",
   "name": "Chestnut Brown",
   "hex": "#503E1E",
   "row": 5,
   "col": 2
  },
  {
   "id": "rav",
   "code": "RAV",
   "name": "Raven",
   "hex": "#18343D",
   "row": 5,
   "col": 3
  },
  {
   "id": "mib",
   "code": "MIB",
   "name": "Midnight Black",
   "hex": "#141D23",
   "row": 5,
   "col": 4
  },
  {
   "id": "aug",
   "code": "AUG",
   "name": "Autumn Green",
   "hex": "#514D25",
   "row": 5,
   "col": 5
  },
  {
   "id": "twb",
   "code": "TWB",
   "name": "Twilight Blue",
   "hex": "#316482",
   "row": 5,
   "col": 6
  },
  {
   "id": "slg",
   "code": "SLG",
   "name": "Slate Grey",
   "hex": "#485765",
   "row": 5,
   "col": 7
  },
  {
   "id": "esp",
   "code": "ESP",
   "name": "Espresso",
   "hex": "#341810",
   "row": 5,
   "col": 8
  }
 ]
}